import axios from 'axios'
import errorHandler from './error-handler'

const ROTA = 'https://app.bembomsalgados.com.br/teleentrega/clientes'

export default {
  async cadastrar(clienteDto) {
    try {
      await axios.post(`${ROTA}`, clienteDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async atualizar(clienteDto) {
    try {
      await axios.put(`${ROTA}`, clienteDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPorId(clienteId) {
    try {
      const { data } = await axios.get(`${ROTA}/filtrar-id/${clienteId}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPorContato(contato) {
    try {
      const { data } = await axios.get(
        `${ROTA}/filtrar-contato?contato=${contato}`
      )
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaTodos(pagina = 1) {
    try {
      const { data } = await axios.get(`${ROTA}/todos?pagina=${pagina}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
}
